import { FunctionComponent } from "react";
import StackComponent from "../../../../components/stack";
import CottageRoundedIcon from '@mui/icons-material/CottageRounded';

interface SedeStackComponentProps {
  objectWithValues: any[]
}

const SedeStackComponent: FunctionComponent<SedeStackComponentProps> = ({ objectWithValues }) => {

  return ( <>
    <StackComponent
      icon={<CottageRoundedIcon/>}
      title="Campus"
      total={`${objectWithValues?.length}`}
      valueActual={'Novas 0'}
    />
  </> );
}

export default SedeStackComponent;
